'use client';

import {
    MESSAGES,
    TRUSTED_ORIGIN_PATTERNS,
    type Message,
    type MessageBroker as MessageBrokerType,
    type ObserverFn
} from './types';

const observers: ObserverFn[] = [];

const subscribe = (observer: ObserverFn) => {
    observers.push(observer);
};

const unsubscribe = (observer: ObserverFn) => {
    const index = observers.indexOf(observer);
    if (index !== -1) {
        observers.splice(index, 1);
    }
};

const notify = (message: Message) => {
    observers.forEach((obs) => obs(message));
};

const isTrustedOrigin = (origin: string) => TRUSTED_ORIGIN_PATTERNS.some((pattern) => pattern.test(origin));

const onMessageHandler = (event: Message<any>) => {
    if (!Object.values(MESSAGES).includes(event.data.type) && !isTrustedOrigin(event.origin)) {
        return;
    }

    notify(event);
};

const register = () => {
    if (!window) {
        throw Error('Can NOT register broker! Window not defined!');
    }

    window.addEventListener('message', onMessageHandler);

    return () => window.removeEventListener('message', onMessageHandler);
};

export const MessageBroker: MessageBrokerType = {
    observers,
    subscribe,
    unsubscribe,
    notify,
    register
};
